export enum VTableSelectionType {
    None,
    Single,
    Multi
}
